<template>
  <div class="experience-diff-container margin-general">
    <div class="text-container-md">
      <h2 class="title">{{ title }}</h2>
      <p class="sub-title subtitle-4">
        {{ subTitle }}
      </p>
    </div>
    <div class="text-container-sm">
      <h2 class="title">{{ title }}</h2>
      <p class="sub-title caption-1">
        {{ subTitle }}
      </p>
    </div>
    <div class="icons-container">
      <div class="icons-row">
        <div class="card" v-for="(item, index) in features" :key="index">
          <div class="image-container">
            <img v-if="item.image && (item.image.endsWith('.svg') || item.image.endsWith('.png') || item.image.endsWith('.jpg'))"
                 :src="item.image" :alt="item.alt || 'icono'" class="image" />
            <span v-else class="material-symbols-outlined image" translate="no">{{ item.image }}</span>
          </div>
          <div class="text-container-2">
            <p class="title body-4-bold">{{ $t(item.title) }}</p>
            <p class="sub-title body-4">{{ $t(item.subTitle) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

const props = defineProps({
  title: String,
  subTitle: String,
});

const features = [
  {
    image: "fullscreen_exit",
    title: "home.experience.pips1",
    subTitle: "home.experience.pips2",
  },
  /* {
    image: "percent",
    title: "home.experience.fees1",
    subTitle: "home.experience.fees2",
  }, */
  {
    image: "attach_money",
    title: "home.experience.minDeposit1",
    subTitle: "home.experience.minDeposit2",
  },
  {
    image: "page_info",
    title: "home.experience.upTo1",
    subTitle: "home.experience.upTo2",
  },
  {
    image: "layers", 
    title: "home.experience.big1",
    subTitle: "home.experience.big2",
  },
  {
    image: "speed",
    title: "home.experience.small1",
    subTitle: "home.experience.small2",
  },
  /* {
    image: "devices",
    title: "home.experience.trading1",
    subTitle: "home.experience.trading2",
  }, */
];
</script>